import API from "../../../app/api";
export const getBannercategories = async () => {
  try {
    const res = await API.get("/banners/categories");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch categories");
    }
    return res.data?.data || [];
  } catch (error) {
    console.error("getBannercategories error:", error);
    return [];
  }
};